<template>

<div class="vx-card p-6">

  <vx-card card-border class="mb-4" title="Detalle del tipo de documento" title-color="dark" collapseAction>
    <div class="vx-row mb-2">
      <div class="vx-col sm:w-1/2 w-full">
        <div>
          <span>Tipo de documento</span>
        </div>
        <div>
          <vs-input disabled class="w-full" name="nombre" v-model="tipoDocumento.nombre"/>
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <div class="vx-col w-full mb-3">
          <span>Tipo de documento inactivo/activo</span>
        </div>
        <div class="vx-col w-full">
          <vs-switch disabled vs-type="success" v-model="tipoDocumento.activo"/>
        </div>
      </div>      
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col sm:w-1/2 w-full">
        <div>
          <span>Categoría</span>
        </div>
        <div>
          <vs-input disabled class="w-full" name="categoria" v-model="tipoDocumento.categoria"/>
        </div>
      </div>
      <div class="vx-col sm:w-1/2 w-full">
        <div v-if="tipoDocumento.categoria==='MANUAL'">
          <span>Operador</span>
        </div>
        <div v-if="tipoDocumento.categoria==='MANUAL'">
          <vs-input disabled class="w-full" name="operador" v-model="tipoDocumento.operador"/>
        </div>
      </div>
    </div>
  </vx-card>

  <div class="vx-row" id="account-manage-buttons">
      <div class="vx-col sm:w-1/2 flex w-full">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{ name: 'valTiposDocumentosEditar', params: { tipoDocumentoId: $route.params.tipoDocumentoId }}">Editar</vs-button>
          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Borrar</vs-button>
      </div>
      <div class="vx-col sm:w-1/2 flex w-full justify-end">
          <vs-button color="warning" type="border" :to="{ name: 'valTiposDocumentos' }">Cancelar</vs-button>
      </div>
  </div>
</div>

</template>

<script>
// Store Module
import valTiposDocumentosStore from '@/store/configuracion/val-tipos-documentos/index.js'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      valTiposDocumentos: [],
      tipoDocumento: {
        nombre: '',
        activo: false,
        categoria: ''
      }
    }
  },
  computed: {
  },
  methods:{
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmación de borrado',
        text: `¿Seguro que quiere eliminar el tipo de documento "${this.tipoDocumento.nombre}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar'
      })
    },
    deleteRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      this.$store.dispatch('valTiposDocumentosStore/deleteTipoDocumento', this.tipoDocumento.id)
        .then(()   => { 
          this.showDeleteSuccess()
          this.$router.push({ name: 'valTiposDocumentos' })
        })
        .catch(error => { this.showDeleteError(error) })
    },
    showDeleteSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'Registro eliminado',
        text: 'El tipo de documento ha sido eliminado correctamente.'
      })
    },
    showDeleteError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'Error eliminando el tipo de documento',
        text: error
      })
    }
  },
  async created () {
    if (!valTiposDocumentosStore.isRegistered) {
      this.$store.registerModule('valTiposDocumentosStore', valTiposDocumentosStore)
      valTiposDocumentosStore.isRegistered = true
    }

    await this.$store.dispatch('valTiposDocumentosStore/getTiposDocumentos')
      .then(() => {
        // Recorremos os tipo de documentos e se están activos engadímolas ao combo
        this.$store.state.valTiposDocumentosStore.tiposDocumentos.forEach(element => {
          if (element.activo) this.valTiposDocumentos.push(element)
        })
      })
      .catch((error) => {
        console.log(error)
      })

    const tipoDocumentoId = this.$route.params.tipoDocumentoId
    const idx = this.$store.state.valTiposDocumentosStore.tiposDocumentos.findIndex((u) => u.id == tipoDocumentoId)
    this.tipoDocumento = this.$store.state.valTiposDocumentosStore.tiposDocumentos[idx]
  }
}
</script>